import {
  ManagePack,
  DashboardIcon,
  Notepad,
  Book,
  Leader,
  ClientNav,
  Employee,
  Report,
  InvoiceNav,
  Timesheet,
  Settings,
  Efiling,
  TaxService,
  ClientTaxPlaning,
  ClientContactUs,
  ClientMsg,
  ClientReferal,
  ClientServices,
  Payment,
  NewClientRequestIcon,
  Hrms,
} from "../../images";
import {
  EFILING_ADMIN_EXTRA_EMPLOYEE_IDS,
  canAccessEfilingPage,
  canEditEfilingFilerComment,
  canEditEfilingAdminFields,
  canEditEfilingRecord,
  isEfilingPowerUser,
} from "../../utils/efilingAccess";
import { canManageSignupClients } from "../../utils/clientSignupRouting";
import { canManageDocumentTemplates } from "../../utils/documentTemplateAccess";

// Helper function to create role-based paths
const createRolePath = (role, path) => `/finlo/${role}${path}`;

export {
  EFILING_ADMIN_EXTRA_EMPLOYEE_IDS,
  canAccessEfilingPage,
  canEditEfilingFilerComment,
  canEditEfilingAdminFields,
  canEditEfilingRecord,
};

export const isEfilingAllowlistedUser = isEfilingPowerUser;

/** @deprecated Use isEfilingAllowlistedUser from efilingAccess */
export function isEfilingAllowlistedEmployee(userId) {
  return isEfilingPowerUser(userId);
}

/** @deprecated Use canAccessEfilingPage */
export function canAccessEfilingAdmin() {
  return canAccessEfilingPage();
}

export function createEfilingMenuItem(role) {
  return {
    id: "efiling",
    item: "E-filing",
    icon: InvoiceNav,
    path: createRolePath(role, "/efiling"),
  };
}

const createNewClientRequestsMenuItem = (role) => ({
  id: "new_client_requests",
  item: "New Clients Request",
  icon: NewClientRequestIcon,
  path: createRolePath(role, "/new_client_requests"),
});

//-------- FYR:: redirect path must contain menu id to active respective menu item ---------//

const ClientMenu = [
  {
    id: "dashboard",
    item: "Dashboard",
    icon: DashboardIcon,
    path: createRolePath("client", "/dashboard"),
  },
  {
    id: "my_services",
    item: "My Service",
    icon: ClientServices,
    path: createRolePath("client", "/my_services"),
  },
  {
    id: "documents",
    item: "Documents",
    icon: Book,
    path: createRolePath("client", "/documents"),
  },
  {
    id: "businesses",
    item: "Businesses",
    icon: ClientServices,
    path: createRolePath("client", "/businesses"),
  },
  {
    id: "payment",
    item: "Payments",
    icon: Payment,
    path: createRolePath("client", "/payment"),
  },
  {
    id: "messages",
    item: "Messages",
    icon: ClientMsg,
    path: createRolePath("client", "/messages"),
  },
  {
    id: "tax_strategy",
    item: "Tax Planning",
    icon: ClientTaxPlaning,
    path: createRolePath("client", "/tax_strategy"),
  },
  {
    id: "referral",
    item: "Refer a Friend",
    icon: ClientReferal,
    path: createRolePath("client", "/referral"),
  },
  {
    id: "our_services",
    item: "Our Service",
    icon: TaxService,
    path: createRolePath("client", "/our_services"),
  },
  {
    id: "contact_us",
    item: "Help & Support",
    icon: ClientContactUs,
    path: createRolePath("client", "/contact_us"),
  },
  {
    id: "my_tax_team",
    item: "My Professionals",
    icon: Leader,
    path: createRolePath("client", "/my_tax_team"),
  },
];
const AdminMenu = [
  {
    id: "dashboard",
    item: "Dashboard",
    icon: DashboardIcon,
    path: createRolePath("admin", "/dashboard"),
  },
  {
    id: "client",
    item: "Clients",
    icon: ClientNav,
    path: createRolePath("admin", "/client"),
  },
  createNewClientRequestsMenuItem("admin"),
  {
    id: "invoice_contract",
    item: "Invoices",
    icon: InvoiceNav,
    path: createRolePath("admin", "/invoice_contract"),
  },
  // {
  //   id: "documents",
  //   item: "Documents",
  //   icon: Book,
  //   path: createRolePath("admin", "/documents"),
  // },
  // {
  //   id: "feedback",
  //   item: "Feedback",
  //   icon: Client,
  //   path: createRolePath("admin", "/feedback"),
  // },
  {
    id: "referral",
    item: "Referral Program",
    icon: ClientReferal,
    path: createRolePath("admin", "/referral"),
  },
  // {
  //   id: "leaves",
  //   item: "Leaves",
  //   icon: Notepad,
  //   path: createRolePath("admin", "/leaves"),
  // },
  // {
  //   id: "performance_index",
  //   item: "Performance Index",
  //   icon: Report,
  //   path: createRolePath("admin", "/performance_index"),
  // },
  // {
  //   id: "manage_client_role",
  //   item: "Manage Client Role",
  //   icon: Settings,
  //   path: createRolePath("admin", "/manage_client_role"),
  // },
  // {
  //   id: "client_transfer",
  //   item: "Client Transfer",
  //   icon: ClientNav,
  //   path: createRolePath("admin", "/client_transfer"),
  // },
  {
    id: "efiling",
    item: "E-filing",
    icon: Efiling,
    path: createRolePath("admin", "/efiling"),
  },
  {
    id: "templates",
    item: "Templates",
    icon: Book,
    path: createRolePath("admin", "/templates"),
  },
  {
    id: "businesses",
    item: "Businesses",
    icon: ClientServices,
    path: createRolePath("admin", "/businesses"),
  },
  {
    id: "employees",
    item: "Employees",
    icon: Employee,
    path: createRolePath("admin", "/employees"),
  },
  {
    id: "reports",
    item: "Reports",
    icon: Report,
    path: createRolePath("admin", "/reports"),
  },

  {
    id: "timesheet_dashboard",
    item: "Timesheet",
    icon: Timesheet,
    path: createRolePath("admin", "/timesheet_dashboard"),
  },
  {
    id: "HRMS",
    item: "HRMS",
    icon: Hrms,
    path: createRolePath("admin", "/hrms"),
  },
];
const ManagerMenu = [
  {
    id: "dashboard",
    item: "Dashboard",
    icon: DashboardIcon,
    path: createRolePath("manager", "/dashboard"),
  },
  {
    id: "client",
    item: "Clients",
    icon: ClientNav,
    path: createRolePath("manager", "/client"),
  },
  {
    id: "invoice_contract",
    item: "Invoices",
    icon: InvoiceNav,
    path: createRolePath("manager", "/invoice_contract"),
  },
  // {
  //   id: "documents",
  //   item: "Documents",
  //   icon: Book,
  //   path: createRolePath("manager", "/documents"),
  // },
  // {
  //   id: "feedback",
  //   item: "Feedback",
  //   icon: Client,
  //   path: createRolePath("manager", "/feedback"),
  // },
  {
    id: "referral",
    item: "Referral Program",
    icon: Leader,
    path: createRolePath("manager", "/referral"),
  },
  // {
  //   id: "leaves",
  //   item: "Leaves",
  //   icon: Notepad,
  //   path: createRolePath("manager", "/leaves"),
  // },
  // {
  //   id: "performance_index",
  //   item: "Performance Index",
  //   icon: Report,
  //   path: createRolePath("manager", "/performance_index"),
  // },
  // {
  //   id: "manage_client_role",
  //   item: "Manage Client Role",
  //   icon: Settings,
  //   path: createRolePath("manager", "/manage_client_role"),
  // },
  // {
  //   id: "client_transfer",
  //   item: "Client Transfer",
  //   icon: ClientNav,
  //   path: createRolePath("manager", "/client_transfer"),
  // },
  {
    id: "efiling",
    item: "E-filing",
    icon: Efiling,
    path: createRolePath("manager", "/efiling"),
  },
  {
    id: "businesses",
    item: "Businesses",
    icon: ClientServices,
    path: createRolePath("manager", "/businesses"),
  },
  {
    id: "employees",
    item: "Employees",
    icon: Employee,
    path: createRolePath("manager", "/employees"),
  },
  {
    id: "reports",
    item: "Reports",
    icon: Report,
    path: createRolePath("manager", "/reports"),
  },

  {
    id: "timesheet_dashboard",
    item: "Timesheet",
    icon: Timesheet,
    path: createRolePath("manager", "/timesheet_dashboard"),
  },
  {
    id: "HRMS",
    item: "HRMS",
    icon: Hrms,
    path: createRolePath("manager", "/hrms"),
  },
];
const EmployeeMenu = [
  {
    id: "dashboard",
    item: "Dashboard",
    icon: DashboardIcon,
    path: createRolePath("employee", "/dashboard"),
  },
  {
    id: "client",
    item: "Clients",
    icon: ClientNav,
    path: createRolePath("employee", "/client"),
  },
  {
    id: "invoice_contract",
    item: "Invoices",
    icon: InvoiceNav,
    path: createRolePath("employee", "/invoice_contract"),
  },
  // {
  //   id: "documents",
  //   item: "Documents",
  //   icon: Book,
  //   path: createRolePath("employee", "/documents"),
  // },
  // { id: "reports", item: "Reports", icon: Report, path: createRolePath("employee", "/reports") },
  // {
  //   id: "feedback",
  //   item: "Feedback",
  //   icon: Client,
  //   path: createRolePath("employee", "/feedback"),
  // },
  {
    id: "referral",
    item: "Referral Program",
    icon: Leader,
    path: createRolePath("employee", "/referral"),
  },
  // {
  //   id: "leaves",
  //   item: "Leaves",
  //   icon: Notepad,
  //   path: createRolePath("employee", "/leaves"),
  // },
  // {
  //   id: "manage_client_role",
  //   item: "Manage Client Role",
  //   icon: Settings,
  //   path: createRolePath("employee", "/manage_client_role"),
  // },
  {
    id: "efiling",
    item: "E-filing",
    icon: Efiling,
    path: createRolePath("employee", "/efiling"),
  },
  {
    id: "businesses",
    item: "Businesses",
    icon: ClientServices,
    path: createRolePath("employee", "/businesses"),
  },
  {
    id: "timesheet_dashboard",
    item: "Timesheet",
    icon: Timesheet,
    path: createRolePath("employee", "/timesheet_dashboard"),
  },
  {
    id: "HRMS",
    item: "HRMS",
    icon: Hrms,
    path: createRolePath("employee", "/hrms"),
  },
];

/** Employees who may open Employees and create or edit employee records. */
const EMPLOYEE_DIRECTORY_MANAGER_IDS = [
  "e92cd405-d06f-481b-bac7-93a580f774c9",
  "19d4def0-d7b4-498b-9d2a-7f8c5efc649c",
];

function canManageEmployeeDirectory(employeeId) {
  return EMPLOYEE_DIRECTORY_MANAGER_IDS.includes(
    String(employeeId || "").trim(),
  );
}

function withTemplatesMenu(menu, role) {
  if (!canManageDocumentTemplates()) return menu;
  if (menu.some((item) => item.id === "templates")) return menu;
  const item = {
    id: "templates",
    item: "Templates",
    icon: Book,
    path: createRolePath(role, "/templates"),
  };
  const efilingIndex = menu.findIndex((entry) => entry.id === "efiling");
  if (efilingIndex === -1) return [...menu, item];
  return [
    ...menu.slice(0, efilingIndex + 1),
    item,
    ...menu.slice(efilingIndex + 1),
  ];
}

function withEmployeeDirectoryMenu(menu, role) {
  const employeeId = localStorage.getItem("user_id");
  if (!canManageEmployeeDirectory(employeeId)) return menu;
  if (menu.some((item) => item.id === "employees")) return menu;
  const item = {
    id: "employees",
    item: "Employees",
    icon: Employee,
    path: createRolePath(role, "/employees"),
  };
  const timesheetIndex = menu.findIndex(
    (entry) => entry.id === "timesheet_dashboard",
  );
  if (timesheetIndex === -1) return [...menu, item];
  return [
    ...menu.slice(0, timesheetIndex),
    item,
    ...menu.slice(timesheetIndex),
  ];
}

export function getEmployeeNavMenu() {
  const employeeId = localStorage.getItem("user_id");
  const menu = canManageSignupClients(employeeId)
    ? [
        ...EmployeeMenu.slice(0, 2),
        createNewClientRequestsMenuItem("employee"),
        ...EmployeeMenu.slice(2),
      ]
    : EmployeeMenu;
  return withTemplatesMenu(withEmployeeDirectoryMenu(menu, "employee"), "employee");
}

export function getManagerNavMenu() {
  const employeeId = localStorage.getItem("user_id");
  const menu = canManageSignupClients(employeeId)
    ? [
        ...ManagerMenu.slice(0, 2),
        createNewClientRequestsMenuItem("manager"),
        ...ManagerMenu.slice(2),
      ]
    : ManagerMenu;
  return withTemplatesMenu(menu, "manager");
}

export { AdminMenu, ClientMenu, EmployeeMenu, ManagerMenu, createRolePath };
